function configure(Highcharts) {
    /**
     * Extend the Axis.getLinePath method in order to visualize breaks with two parallel
     * slanted lines. For each break, the slanted lines are inserted into the line path.
     */
    Highcharts.wrap(Highcharts.Axis.prototype, "getLinePath", function (proceed, lineWidth) {
        var axis = this, path = proceed.call(this, lineWidth), start = path[0], x = start[1], y = start[2];
        //@ts-ignore this.breakArray is internal.
        Highcharts.each(this.breakArray || [], function (brk) {
            if (axis.horiz) {
                x = axis.toPixels(brk.from, false);
                path.splice(1, 0, ['L', x - 4, y], // stop
                ['M', x - 9, y + 5], ['L', x + 1, y - 5], // left slanted line
                ['M', x - 1, y + 5], ['L', x + 9, y - 5], // higher slanted line
                ['M', x + 4, y]);
            }
            else {
                y = axis.toPixels(brk.from, false);
                path.splice(1, 0, ['L', x, y - 4], // stop
                ['M', x + 5, y - 9], ['L', x - 5, y + 1], // lower slanted line
                ['M', x + 5, y - 1], ['L', x - 5, y + 9], // higher slanted line
                ['M', x, y + 4]);
            }
        });
        return path;
    });
    /**
     * On top of each column, draw a zigzag line where the axis break is.
     */
    Highcharts.wrap(Highcharts.Series.prototype, "init", function (proceed, chart, options) {
        proceed.call(this, chart, options);
        if (this.yAxis) {
            Highcharts.addEvent(this.yAxis, "pointBreak", function (e) {
                var point = e.point;
                var brk = e.brk;
                var shapeArgs = point.shapeArgs;
                var x = shapeArgs.x;
                //@ts-ignore this.translate is internal.
                var y = this.translate(brk.from, 0, 1, 0, 1);
                var w = shapeArgs.width;
                var key = ["brk", brk.from, brk.to].join("-");
                var path = ["M", x, y, "L", x + w * 0.25, y + 4, "L", x + w * 0.75, y - 4, "L", x + w, y];
                if (!point[key]) {
                    point[key] = this.chart.renderer.path(path)
                        .attr({
                        "stroke-width": 2,
                        stroke: point.series.options.borderColor
                    })
                        .add(point.graphic.parentGroup);
                }
                else {
                    point[key].attr({
                        d: path
                    });
                }
            });
        }
    });
}
export default configure;
